$(document).on('click', '.product__page .recharge-subscription-widget', function() {
  setTimeout(function() {
    document.querySelectorAll('recharge-subscription-widget').forEach((card) => {
      var shadow = card.shadowRoot;
      var priceEl = shadow.querySelector('[rc-selected] .rc-price:not(.strike-through)');

      if (priceEl) {
        var clone = priceEl.cloneNode(true);
        clone.querySelectorAll('.visually-hidden').forEach(el => el.remove());
        var priceText = clone.textContent.trim();
        $('.product__price_nws .product__price').text(priceText);
        var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
        var quantity = parseInt($('.product .quantity__input').val()) || 1;
        var total = price.toFixed(2);
        $(".product__page product-form .product__submit__item button .price-show-btn").text(`$${total}`);
      }
    });
  }, 500);
});
function changeprice(){
  if($(".product__page recharge-subscription-widget").length == 0){
    var priceText = $('.product__price_nws .product__price').text();
        var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
        var quantity = parseInt($('.product .quantity__input').val()) || 1;
        var total = price.toFixed(2);
        $(".product__page product-form .product__submit__item button .price-show-btn").text(`$${total}`);
}
  document.querySelectorAll('.product__page recharge-subscription-widget').forEach((card) => {
      var shadow = card.shadowRoot;
      var priceEl = shadow.querySelector('[rc-selected] .rc-price:not(.strike-through)');
      if (priceEl) {   
        var clone = priceEl.cloneNode(true);
        clone.querySelectorAll('.visually-hidden').forEach(el => el.remove());
        var priceText = clone.textContent.trim();
        $('.product__price_nws .product__price').text(priceText);
        var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
        var quantity = parseInt($('.product .quantity__input').val()) || 1;
        var total = price.toFixed(2);
        $(".product__page product-form .product__submit__item button .price-show-btn").text(`$${total}`);
      }
    });
}

const observer = new MutationObserver((mutations, obs) => {
  const rechargeWidget = document.querySelector('recharge-subscription-widget');
  if (rechargeWidget) {
    setTimeout(function(){
    changeprice()
    
    },2000);
    setTimeout(function(){
    changeprice()
    
    },4500);
    obs.disconnect(); 
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});
var backButton = '<div class="slick-prev slick-arrow"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="-0.5" y="0.5" width="43" height="43" rx="4.5" transform="matrix(-1 0 0 1 43 0)" stroke="#242431"/><path d="M25.3 12.8L15.7 22L25.3 31.2" stroke="#242431"/></svg></div>';
var nextButton = '<div class="slick-next slick-arrow"><svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="43" height="43" rx="4.5" stroke="#242431"/><path d="M18.6998 12.8L28.2998 22L18.6998 31.2" stroke="#242431"/></svg></div>';
$(document).ready(function(){
     $('.slider-cust-rev-s').slick({
        dots: false,
        infinite: false,
        
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 1,
        slidesToScroll: 1,
        appendArrows: ".main-ppl-rev .slider-arws-c",
        responsive: [
           {
            breakpoint: 750,
                settings: {
                arrows: false,
                dots: true
                }
            },
           
        ]
    });
     $(".main-products-list.with-prod-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow: backButton,
        nextArrow: nextButton,
     appendArrows: ".main-custom-coll .slider-arws-c",
    dots: false,
   infinite:false,
   responsive: [
    
      {
        breakpoint: 992,
        settings: {
           slidesToShow: 2,
   
        }
      },
      {
        breakpoint: 750,
        settings: {
    arrows:false,
    slidesToShow: 2,
   dots: true,
        }
      },
      {
        breakpoint: 577,
        settings: {
           slidesToShow: 1,
    arrows:false,
    dots: true,
        }
      },
     
      
          ]
   
 });
  $('.read-blog-section .read-blog-list').slick({
        dots: false,
        infinite: false,
        arrows:false,
        slidesToShow: 3,
        slidesToScroll: 1,
       
        responsive: [
           {
            breakpoint: 992,
                settings: {
                slidesToShow: 2,
                dots:true,
                }
            },
           {
            breakpoint: 750,
                settings: {
                slidesToShow: 1,
                  dots:true,
                }
            }
        ]
    });
    $('.ingredients-slider').slick({
  dots: false,
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: backButton,
  nextArrow: nextButton,
  appendArrows: ".ingredients-section .ingredients-arrows",
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 750,
      settings: {
        slidesToShow: 2,
        arrows: false
      }
    },
    {
      breakpoint: 577,
      settings: {
        slidesToShow: 1.11,
        arrows: false
      }
    }
  ]
});

      $('.insta-section .slider-parent-insta').slick({
        dots: false,
        infinite: false,
        prevArrow: backButton,
        nextArrow: nextButton,
        slidesToShow: 4,
        slidesToScroll: 1,
        appendArrows: ".insta-section .slider-arws-c",
        responsive: [
           {
            breakpoint: 1200,
                settings: {
                slidesToShow: 3,
                
                }
            },
           {
            breakpoint: 992,
                settings: {
                slidesToShow: 2,
                
                }
            },
            {
            breakpoint: 750,
                settings: {
                slidesToShow: 2,
                 arrows:false
                
                }
            },
            {
            breakpoint: 577,
                settings: {
                slidesToShow: 1.15,
                 arrows:false
                
                }
            },
        ]
    });
    $(document).on('click', '.single-insta-block video', function () {
  const currentVideo = this;

  $('.single-insta-block video').not(currentVideo).each(function () {
    this.pause();
  });
 
  // Toggle play / pause
  if (currentVideo.paused) {
    currentVideo.play();
  } else {
    currentVideo.pause();
  }
});
 $(".single-insta-block video").on("pause", function () {
    $(this).parent().find(".play-pause-svg").show();
  });
  $(".single-insta-block video").on("playing", function () {
    $(this).parent().find(".play-pause-svg").hide();
  });
   $('.socials-images.socials-images-mob').slick({
        dots: false,
        infinite: true,
        arrows:false,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
        autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: "linear",
   });
    $(document).on('click','a.pop-up-link',function(){
      $('body').addClass('full-ingredients-open');
      var dataattr = $(this).attr("open-pop-name");
$(".full_ingredients_popup[data-pop-name='" + dataattr + "']").addClass("active");
    });
    $(document).on('click','.full_ingredients_popup .close-ingredients',function(){
       $('body').removeClass('full-ingredients-open');
       $(".full_ingredients_popup").removeClass("active");
    });
    
      $(window).on('click', function (e) {
        if ($(e.target).is('#customPopup')) {         
           $('body').removeClass('full-ingredients-open');
           $(".full_ingredients_popup").removeClass("active");
        }
      });
})